import { gql } from '@apollo/client';
import { PLATFORM_FIELDS } from 'src/graphql/entities/platform-user';
import { USER_GROUP_FIELDS } from 'src/graphql/entities/user-group';

export const SUPPORT_POLICY_FIELDS = gql`
  fragment SupportPolicyFields on SupportPolicy {
    id
    supportPolicyId
    partnerId
    type
    category
    title
    description
    pinnedAt
    archivedAt
    validUntil
    addressIds
    clientIds
    clientToAddressIds
    conditions
    urgencyLevel
    escalationRules
    createdAt
    updatedAt
    createdBy
  }
`;

export const SUPPORT_POLICY_RELATIONS = gql`
  fragment SupportPolicyRelations on SupportPolicy {
    id
    userGroups {
      ...UserGroupFields
    }
    createdByUser {
      ...PlatformUserFields
    }
  }
  ${USER_GROUP_FIELDS}
  ${PLATFORM_FIELDS}
`;
